import { httpService } from './HttpService';
import ApiPaths from './ApiPaths';

export interface GroupEditItemEntry {
  sessionId: string;
  itemId: string;
  newQty: number;
}

export interface GroupEditRequest {
  comment?: string;
  edits: GroupEditItemEntry[];
}

export interface GroupEditItemResult {
  itemId: string;
  partNumber: string;
  sessionId: string;
  sessionTitle: string;
  /** ISO string snapshot of the session's closed date. May be absent for older records. */
  sessionDate?: string;
  shipQtd: number;
  qtyBefore: number;
  qtyAfter: number;
  deliveryNotes: string[];
}

export interface GroupEditResponse {
  groupEditId: string;
  createdAt: string;
  createdByName: string;
  comment?: string;
  /** Aggregated unique delivery notes across all items in this batch. */
  deliveryNotes?: string[];
  warnings?: string[];
  items: GroupEditItemResult[];
}

export interface GroupEditPageResponse {
  content: GroupEditResponse[];
  page: number;
  size: number;
  totalCount: number;
  hasMore: boolean;
}

export type GroupEditSort = 'DATE_DESC' | 'DATE_ASC' | 'PART_ASC';

export const createGroupEdit = async (request: GroupEditRequest): Promise<GroupEditResponse> => {
  const response = await httpService.post<GroupEditResponse>(ApiPaths.GROUP_EDITS, request);
  return response.data;
};

export const getGroupEdits = async (params: {
  fromDate?: string;
  toDate?: string;
  partNumber?: string;
  deliveryNotes?: string[];
  sort?: GroupEditSort;
  page?: number;
  size?: number;
}): Promise<GroupEditPageResponse> => {
  const query = new URLSearchParams();
  if (params.fromDate) query.append('fromDate', params.fromDate);
  if (params.toDate) query.append('toDate', params.toDate);
  if (params.partNumber) query.append('partNumber', params.partNumber);
  if (params.sort) query.append('sort', params.sort);
  if (params.page !== undefined) query.append('page', String(params.page));
  if (params.size !== undefined) query.append('size', String(params.size));
  // Repeatable param — Spring reads as List<String>
  if (params.deliveryNotes) {
    params.deliveryNotes.forEach(dn => query.append('deliveryNotes', dn));
  }

  const response = await httpService.get<GroupEditPageResponse>(
    `${ApiPaths.GROUP_EDITS}?${query.toString()}`
  );
  return response.data;
};
